// extracted by mini-css-extract-plugin
export var nextButton = "ArrowButton-module--nextButton--1criZ";
export var small = "ArrowButton-module--small--1RBTv";
export var content = "ArrowButton-module--content--3ASPJ";
export var arrow = "ArrowButton-module--arrow--1jtj7";
export var position = "ArrowButton-module--position--st3tP";
export var backButton = "ArrowButton-module--backButton--1U3ND";